"use client";
import { useState } from "react";
import ICON_ARROW_UP from "@/assets/images/arrow-up.svg";
import ICON_ARROW_UP_DARK from "@/assets/images/arrow_up_white_leagues.svg";
import { useTheme } from "@/context/ThemeContext";

export default function FinanceeMatchLeagues({ league, matches, render = () => {} }) {
  const { isDark } = useTheme();
  const [isExpanded, setIsExpanded] = useState(true);
  const { name, logo } = league;

  return (
    <div className="flex flex-col flex-wrap w-full overflow-hidden rounded-xl border-2 border-[rgba(200,211,255,1)] bg-[#f6f8ff]">
      <div
        className="flex items-center gap-2.5 pl-2.5 pr-[5px] py-[5px] cursor-pointer select-none uppercase text-[13px] font-normal border-b border-[rgba(200,211,255,1)] text-[#2d2d2d] w-full bg-[#fff6d9]"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <img
          className={`w-[20px] h-[20px] shrink-0 transition-transform ${isExpanded ? "rotate-180" : ""}`}
          src={isDark ? ICON_ARROW_UP_DARK : ICON_ARROW_UP}
          alt=""
          width={20}
          height={20}
        />
        <div className="flex items-center gap-2.5 flex-1 min-w-0">
          {logo && (
            <img
              src={logo}
              alt={name}
              className="w-[15px] h-[15px] object-contain shrink-0"
              width={15}
              height={15}
              loading="lazy"
            />
          )}
          <span className="flex-1 min-w-0 truncate">{name}</span>
        </div>
      </div>

      {isExpanded && (
        <div className="flex flex-col gap-2  w-full rounded-b-xl bg-[#f6f8ff] font-normal">
          {matches.map((match) => render(match))}
        </div>
      )}
    </div>
  );
}
